const logo = require("../assets/images/logo.png");
const Avatar = require("../assets/images/avatar5.png");

export const IMAGES = {
  logo: logo.default,
  Avatar: Avatar.default,
};
